import axios from "axios";
import { deleteCookie } from "./deleteCookie";

export const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "/api",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

const refreshInstance = axios.create({
  baseURL: process.env.REACT_APP_BACKEND_URL || "/api",
  withCredentials: true,
  headers: {
    "Content-Type": "application/json",
  },
});

export const useAxiosInterceptor = () => {
  axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
      const originalRequest = error.config;
      if (error.response.status === 401) {
        if (!originalRequest._retry) {
          originalRequest._retry = true;
          const response = await refreshInstance.post("/auth/refresh", {});
          if (response.status === 200) {
            return axiosInstance(originalRequest);
          }
        } else {
          deleteCookie("access-token");
          deleteCookie("refresh-token");
          window.location.href = "/login";
          return Promise.reject(error);
        }
      }
      return Promise.reject(error);
    },
  );
};

export default useAxiosInterceptor;
